import { render, staticRenderFns } from "./AnnotatedImage.vue?vue&type=template&id=6b6c445d&"
import script from "./AnnotatedImage.vue?vue&type=script&lang=js&"
export * from "./AnnotatedImage.vue?vue&type=script&lang=js&"
import style0 from "./AnnotatedImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports